/**
 * Debug utility for list view issues
 * Run in browser console: window.debugListViews()
 */

export function debugListViews() {
  console.log('=== LIST VIEW DEBUG ===\n');

  const objects = ['lead', 'client', 'opportunity', 'case', 'contact', 'event'];

  objects.forEach(obj => {
    const listViewKey = `crm_${obj}_list_views`;
    const recordKey = `crm_${obj}_records`;

    console.log(`\n--- ${obj.toUpperCase()} ---`);

    // Check list views
    const listViews = localStorage.getItem(listViewKey);
    if (listViews) {
      try {
        const parsed = JSON.parse(listViews);
        const defaultView = parsed.find((lv: any) => lv.isDefault);
        if (defaultView) {
          console.log(`List View: "${defaultView.name}"`);
          console.log(`Columns (${defaultView.columns.length}):`);
          defaultView.columns.forEach((col: any) => {
            console.log(`  - ${col.fieldApiName} (${col.fieldLabel}) [visible: ${col.isVisible}]`);
          });

          // Check if ID column exists
          const hasId = defaultView.columns.some((col: any) => col.fieldApiName === 'id');
          console.log(`Has ID column: ${hasId ? '✅ YES' : '❌ NO'}`);
        } else {
          console.log('No default list view found');
        }
      } catch (e) {
        console.log('Error parsing list views:', e);
      }
    } else {
      console.log(`No cached list views (key: ${listViewKey})`);
    }

    // Check records
    const records = localStorage.getItem(recordKey);
    if (records) {
      try {
        const parsed = JSON.parse(records);
        console.log(`Records: ${parsed.length}`);
        if (parsed.length > 0) {
          const first = parsed[0];
          console.log(`First record ID: ${first.id || '❌ MISSING'}`);
          console.log(`First record fields: ${Object.keys(first).join(', ')}`);
        }
      } catch (e) {
        console.log('Error parsing records:', e);
      }
    } else {
      console.log(`No cached records (key: ${recordKey})`);
    }
  });

  console.log('\n\n=== RECOMMENDATIONS ===');
  console.log('If ID columns are missing from list views:');
  console.log('1. Run: localStorage.clear()');
  console.log('2. Refresh the page');
  console.log('3. Run this debug again to verify');

  return 'Debug complete - check console output';
}

// Also export a function to force reset list views only
export function resetListViews() {
  const keys = [
    'crm_lead_list_views',
    'crm_client_list_views',
    'crm_opportunity_list_views',
    'crm_case_list_views',
    'crm_contact_list_views',
    'crm_event_list_views'
  ];

  keys.forEach(key => {
    localStorage.removeItem(key);
    console.log(`Removed: ${key}`);
  });

  console.log('\nList views reset. Refresh the page to load new configurations.');
  return 'List views reset complete';
}

// Make available globally
if (typeof window !== 'undefined') {
  (window as any).debugListViews = debugListViews;
  (window as any).resetListViews = resetListViews;
}
